const KEYS = {
  place: 'cnc_place',
  preferred: 'cnc_preferred_boutique',
  selected: 'cnc_selected_boutique',
};

function readJson(storage, key) {
  try {
    const raw = storage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function writeJson(storage, key, value) {
  if (value == null) {
    storage.removeItem(key);
    return;
  }
  storage.setItem(key, JSON.stringify(value));
}

export function getPlace() {
  return readJson(localStorage, KEYS.place);
}

export function setPlace(place) {
  writeJson(localStorage, KEYS.place, place);
}

export function getPreferredBoutique() {
  return readJson(localStorage, KEYS.preferred);
}

export function setPreferredBoutique(boutique) {
  writeJson(localStorage, KEYS.preferred, boutique);
}

export function getSelectedBoutique() {
  return readJson(sessionStorage, KEYS.selected);
}

export function setSelectedBoutique(boutique) {
  writeJson(sessionStorage, KEYS.selected, boutique);
}

export function clearSelectedBoutique() {
  sessionStorage.removeItem(KEYS.selected);
}
